class CartNotification extends HTMLElement {
  constructor() {
    super()

    this.notification = document.getElementById('cart-notification')
    this.duration = this.dataset.duration
    this.header = document.querySelector('sticky-header')
    this.onBodyClick = this.handleBodyClick.bind(this)
    this.sectionHeader = document.querySelector('#shopify-section-header')

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    )
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    )
  }

  open() {
    this.notification.classList.add('animate', 'active')
    this.sectionHeader.style.zIndex = '999999999999'
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus()
        trapFocus(this.notification)
      },
      { once: true }
    )

    document.body.addEventListener('click', this.onBodyClick)
    this.duration && setTimeout(this.close.bind(this), this.duration)
  }

  close() {
    this.notification.classList.remove('active')
    this.sectionHeader.style.zIndex = ''
    document.body.removeEventListener('click', this.onBodyClick)

    removeTrapFocus(this.activeElement)
  }

  renderContents(parsedState, product_title) {
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = `
        <div class="capitalize cart-notification-product__info">
        <div class="cart-notification__image">
          <img src="${parsedState.image}" alt="${parsedState.image.alt}">
        </div>
        <div>
          <div class="utility cart-notification__title">
            ${product_title || parsedState.product_title}
          </div>
          <div class="cart-notification__data">
            <div class="cart-notification__price">${formatPrice(parsedState.price)}</div>
            |
            <div class="cart-notification__variant">${window.cartStrings.size} ${parsedState.variant_title}</div>
          </div>
        </div>
        `
    })

    this.header?.reveal()
    this.open()
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
    ]
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  handleBodyClick(evt) {
    const target = evt.target
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure')
      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null
      this.close()
    }
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('cart-notification', CartNotification)
